module.exports = __webpack_public_path__ + "img/未标题-3-01.2a28b058.png";